/**
 * Helper Components for Visions Special
 * Reusable UI components for displaying labels and prices
 */
import React from 'react';

interface DashedLabelProps {
  label: string;
  value: string;
  id: string;
}

export const DashedLabel: React.FC<DashedLabelProps> = ({ label, value, id }) => {
  return (
    <div className="flex flex-col justify-center items-center uppercase">
      <span
        id={id}
        className="text-[12px] border-[1px] border-[#D9D9D9] border-dashed px-[4px] py-[1px] rounded-md"
      >
        {label}: {value}
      </span>
    </div>
  );
};

interface DashedPriceProps {
  label: string;
  value: string;
  className?: string;
}

export const DashedPrice: React.FC<DashedPriceProps> = ({ label, value, className }) => {
  return (
    <div
      className={`flex justify-between items-center uppercase
         w-[170px] h-[33px] border-[#D9D9D9] border-[1px]
         border-dashed px-[8px] rounded-md ${className || ''}`}
    >
      <span className="text-[9px] max-w-[44px]">{label}</span>
      <span className="text-[14px] max-w-[100px]">{value}</span>
    </div>
  );
};